import * as Yup from "yup";

const loginValidator = Yup.object().shape({
  email: Yup.string().email("E-mail inválido").required("E-mail"),
  senha: Yup.string().required("Senha"),
});

export default loginValidator;
